import { bindable, customAttribute, inject } from 'aurelia-framework';
import 'bootstrap';
import * as $ from 'jquery';

@customAttribute('bootstrap-tooltip')
@inject(Element)
export class BootstrapTooltip {
	@bindable placement: string = 'bottom';
	@bindable trigger: string = 'hover';
	@bindable html: string = 'true';
	@bindable title: string = ''; // Optional input to fix double tooltip issues with if.binding
	$element: any;

	constructor(element) {
		this.$element = $(element);
	}

	bind() {
		this.$element
			.attr('data-toggle', 'tooltip')
			.attr('data-container', 'body')
			.attr('data-placement', this.placement)
			.attr('data-html', this.html)
			.attr('data-trigger', this.trigger);

		if (this.title) {
			this.$element.tooltip({
				title: this.title
			});
		} else {
			this.$element.tooltip();
		}
	}

	unbind() {
		this.$element.tooltip('dispose');
	}

	titleChanged() {
		this.$element.tooltip({ title: this.title });
	}
}
